/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tolerance_Band_PctInputs */

const en_tolerance_band_pct = /** @type {(inputs: Tolerance_Band_PctInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolerance %`)
};

/**
* | output |
* | --- |
* | "Tolerance %" |
*
* @param {Tolerance_Band_PctInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const tolerance_band_pct = /** @type {((inputs?: Tolerance_Band_PctInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tolerance_Band_PctInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_tolerance_band_pct(inputs)
});